import { StyleState } from './style/StyleState';
import { combineReducers } from 'redux';
import { BreadcrumbState } from './breadcrumb/BreadcrumbState';
import { birdElementReducer } from './birdElement/reducer';
import { TitleState } from './title/TitleState';
import { WarningState } from './warning/WarningState';
import { BirdState } from './bird/birdState';
import { BirdLayoutState } from './birdLayout/BirdLayoutState';
import { LayoutRootState } from './birdLayout/LayoutRootState';
import { BusyState } from './busy/BusyState';
import { SectionState } from './section/SectionState';
import { MessageState } from './message/MessageState';
import { ReportContextMenuState } from './reportContextMenu/ReportContextMenuState';
import { AboutInfoState } from './aboutInfo/AboutInfoState';
import { BirdActionMenuState } from './birdActionMenu/BirdActionMenuState';
import { AutoInteractionState } from './autoInteraction/AutoInteractionState';
import { TransportState } from './transport/transportState';
import { SelectionDisabledState } from './selectiondisabled/SelectionDisabledState';
import { ElementDecoratorState } from './elementDecorator/elementDecoratorState';
import { ObjectOverlaysDisabledState } from './objectOverlaysDisabled/objectOverlaysDisabledState';
import { ZoomState } from './zoom/zoomState';
import { DragModeState } from './dragMode/dragModeState';
import { AccessibilityLabelState } from './accessibilityLabel/accessibilityLabelState';
import { OverviewState } from './overview/overviewState';
import { MaximizeState } from './maximize/maximizeState';
import { ExplanationState } from './explanation/explanationState';
import { PromptHeaderState } from './promptHeader/promptHeaderState';
import { StatusState } from './status/StatusState';
import { ManageColumnsState } from './manageColumns/manageColumnsState';
import { RootState } from './RootState';
import { ObjectSearchState } from './objectSearch/ObjectSearchState';
import { LayerVisibilityState } from './layerVisibility/layerVisibility';
const birdLayoutReducer = combineReducers({
    byId: BirdLayoutState.reducer,
    rootIds: LayoutRootState.reducer,
});
const uiReducer = combineReducers({
    birdLayout: birdLayoutReducer,
    busy: BusyState.reducer,
    selectionDisabled: SelectionDisabledState.reducer,
    message: MessageState.reducer,
    warning: WarningState.reducer,
    status: StatusState.reducer,
    reportContextMenu: ReportContextMenuState.reducer,
    birdActionMenu: BirdActionMenuState.reducer,
    dragMode: DragModeState.reducer,
    zoom: ZoomState.reducer,
    overview: OverviewState.reducer,
    layerVisibility: LayerVisibilityState.reducer,
    elementDecorator: ElementDecoratorState.reducer,
    objectOverlaysDisabled: ObjectOverlaysDisabledState.reducer,
    maximize: MaximizeState.reducer,
    explanation: ExplanationState.reducer,
    promptHeader: PromptHeaderState.reducer,
    manageColumns: ManageColumnsState.reducer,
    objectSearch: ObjectSearchState.reducer,
});
const combinedReducer = combineReducers({
    sections: SectionState.reducer,
    aboutInfo: AboutInfoState.reducer,
    birdElements: birdElementReducer,
    titles: TitleState.reducer,
    styles: StyleState.reducer,
    breadcrumbs: BreadcrumbState.reducer,
    autoInteractions: AutoInteractionState.reducer,
    ui: uiReducer,
    bird: BirdState.reducer,
    transport: TransportState.reducer,
    accessibilityLabel: AccessibilityLabelState.reducer,
});
export function rootReducer(rootReducer, action) {
    const state = combinedReducer(rootReducer, action);
    return RootState.reducer(state, action);
}
